import {Component, OnDestroy, OnInit} from '@angular/core';
import {TourApiService} from '../services/tour-api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs/Rx';
import {TrackingService} from '../services/tracking.service';
import {TourService} from '../services/tour.service';
import {WishlistService} from '../services/wishlist.service';

@Component({
  selector: 'gt-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  private tourLoadSubscription: Subscription;
  private routeParamsSubscription: Subscription;
  // showBuilderButton = false;
  returnUrl: string;
  constructor(public apiService: TourApiService,
              private router: Router,
              private route: ActivatedRoute,
              private trackingService: TrackingService,
              private wishlistService: WishlistService) {}

  ngOnInit() {

    this.tourLoadSubscription = this.apiService.tourLoaded.subscribe(
      (loaded: boolean) => {
        if (loaded) {
          // no need to keep monitoring the route params
          this.trackingService.configurePiwik(this.apiService.builderPath, this.apiService.modelPath);
          this.trackingService.trackAction(TrackingService.kActionMain, 'Load', 0);
          // default to the 'tour/video' path unless a redirectUrl parameter was on the incoming request
          // or... if the tour is web360 only, redirect to the /3d path
          let routes = [];
          let extras = {};
          if (this.returnUrl) {
            routes = this.returnUrlSegements();
            // dont update the History with ?returnURL=XXX
            extras = {replaceUrl: true}; // {skipLocationChange: true};
          } else {
            routes = this.apiService.tourRoutesForContent();
            extras = {replaceUrl: true};
          }
          this.wishlistService.loadWishlist();
          this.returnUrl = null;
          this.router.navigate(routes, extras);
        }
      }
    );

    this.routeParamsSubscription = this.route.params.subscribe(
      (params: any) => {

        // in the event a full URL was requested with no loaded tour
        // http://localhost:4200/avid/madison/feedback
        // http://localhost:4200/pardee/farmhouse/features
        // we were redirected by the tour guard.
        // extract the builder/model and load the tour

        this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
        if (this.returnUrl) {
          const segments = this.returnUrlSegements();
          this.apiService.fetchTourInfoForBuilderAndModel(segments[0], segments[1]);

        } else {

          if (params['alias'] != null) {
            this.apiService.fetchTourInfoForAlias(params['alias']);
          } else if (params['builder'] != null && params['model'] != null) {
            this.apiService.fetchTourInfoForBuilderAndModel(params['builder'], params['model']);
          } else {
            this.router.navigate(['builders'], {replaceUrl: true});
            // this.showBuilderButton = true;
          }
        }
      }
    );
  }

  returnUrlSegements(): string[] {
    if (this.returnUrl) {
      return this.returnUrl.substring(1, this.returnUrl.length).split('/');
    }
    return [];
  }

  ngOnDestroy() {
    this.tourLoadSubscription.unsubscribe();
    this.routeParamsSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home.component.ts